   function callYMK(sku, element){
        var ymkType = $(element).attr("data-ctype");
       if ($(element).attr("data-one-shade")){
           ymkType = '';
       }
        if ($(element).attr("data-cSKU")){
            sku = $(element).attr("data-cSKU");
        }
        YMK.applyMakeupBySku(sku+ymkType);
    }

document.addEventListener("DOMContentLoaded", function() {
    var modal = document.getElementById("perfectModel");
    var ymkmodal = document.getElementById("YMK-module");
    var span = document.getElementsByClassName("close")[0];
    var tryOnButton = document.getElementById("applyColor");
    var closeButton = document.getElementById("closeButton");
    var iconSearch = document.getElementsByClassName("search-wrapper")[0];
    var iconBasket = document.querySelector(".action.showcart.title-cart.with-text");
    var agreePolicy = document.getElementById("agreePolicy");
    var privacyAgreementBox = document.getElementById("privacyAgreementBox");
    var ChooseColor = document.getElementById("ChooseColor");

    (function (d, k) {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://plugins-media.makeupar.com/c39981/sdk.js?apiKey=' + k;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
    })(document, 'VBiwl3ppNJaEDdUs3s8lEg');

    asyncInit();
    function asyncInit(){
        window.ymkAsyncInit = function () {
            YMK.init({
                autoOpen: true
            });
            window.YMK.addEventListener('closed', function() {
                $('.applyColorsBlock').addClass("notactive");
                 window.dataLayer.push({
                    event: 'ymk_closed'
                });
                YMK.init({
                    autoOpen: true
                });
            });

            // check if we can apply color

            window.YMK.addEventListener('engineClosed', function () {
                $('.applyColorsBlock').addClass("notactive");
                 window.dataLayer.push({
                    event: 'ymk_engine_closed'
                });
            });
            window.YMK.addEventListener('loading', function () {
                $('.applyColorsBlock').removeClass("notactive");
            });

            window.YMK.addEventListener('engineClosed', function() {
                $('.tryonColorName').removeClass("activeColor");
            });

            window.YMK.addEventListener('reset', function() {
                $('.tryonColorName').removeClass("activeColor");
            });
        }
    }

    $(agreePolicy).on('click', function (){

        var skuType = $(agreePolicy).attr("data-psku");

        if (skuType){
             ymkmodal.style.display = "block";
            privacyAgreementBox.style.display = "none";
             YMK.init({
                 autoOpen: true
             });
        }else{
            privacyAgreementBox.style.display = "none";
            ChooseColor.style.display = "block";

        }


    });
    $(".colorType").on('click', function(event){
        var CType = this.id;
        $("#applyColor").attr('data-cType',CType);
        ChooseColor.style.display = "none";
        ymkmodal.style.display = "block";
        YMK.init({
            autoOpen: true
        });
    });



    $(".agreedPolicy").change(function() {
        $("#agreePolicy").attr("disabled", !$(this).is(":checked"));
    });

    $('#tryOn').on('click', function (){
        tryOnButton.style.visibility = "hidden";
        closeButton.style.display = "block";
        modal.style.display = "block";
        ymkmodal.style.display = "none";
        privacyAgreementBox.style.display = "block";

        window.YMK.addEventListener('opened', function() {
            tryOnButton.style.visibility = "hidden";
        });

        window.YMK.addEventListener('closed', function() {
            modal.style.display = "none";

            privacyAgreementBox.style.display = "block";
             window.dataLayer.push({
                    event: 'ymk_opened'
                });
        });
        window.YMK.addEventListener('engineClosed', function() {
            tryOnButton.style.visibility = "hidden";
            closeButton.style.display = "block";
        });
        window.YMK.addEventListener('loading', function() {
            tryOnButton.style.visibility = "visible";
            closeButton.style.display = "none";
        });
    });

    span.onclick = function() {
        modal.style.display = "none";
    }

    window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = "none";
        }
    }
});